import { Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Tree from 'react-d3-tree'
import { useNavigate } from 'react-router-dom'
import { useCenteredTree } from './CenteredTree.js'
import AddEmployeeForm from 'components/Forms/StructureForm/AddEmployeeForm/AddEmployeeForm'
import { useLocation } from 'react-router-dom'
import SlidingPaneUtil from 'utils/SlidingPaneUtil'
import userInfo from 'utils/userInfo'
import './custom-tree.css'
import styles from './StructureTreeView.module.scss'
const containerStyles = {
  width: '90vw',
  height: '83vh',
}


export default function StructureTreeView({ data, setRender }) {
  const { t } = useTranslation('common')
  const [translate, containerRef] = useCenteredTree()
  const nodeSize = { x: 300, y: 150 }
  const separation = { siblings: 2, nonSiblings: 2 }
  const foreignObjectProps = { width: nodeSize.x, height: nodeSize.y, x: -125 , y: -55 };

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [width])

  const [state, setState] = useState({
    id: '',
    structure_name: '',
    title: '',
    isPaneOpen: false,
    isPaneOpenLeft: false,
  })
  const navigate = useNavigate()
  const location = useLocation()
  const isSubtasks = location.state?.isSubtasks

  const handleOpen = () => {
    setState({ isPaneOpen: true })
  }

  const buttonStyle = {
    background: 'rgb(169 4 4)',
    border: 'none',
    color: 'white',
    textTransform: 'none',
    fontWeight: 'bold',
    fontFamily: '"Inter", sans-serif',
    fontSize: '14px',
    borderRadius: '6px',

    marginTop: '15px',
    marginLeft: '15px',
  }

  return (
    <div style={containerStyles} ref={containerRef}>
      <Tree
        data={data ?? []}
        translate={translate}
        nodeSize={nodeSize}
        separation={separation}
        transitionDuration="1000"
        pathFunc="step"
        rootNodeClassName="node__root"
        branchNodeClassName="node__branch"
        leafNodeClassName="node__leaf"
        renderCustomNodeElement={(rd3tProps) =>
          renderForeignObjectNode({
            ...rd3tProps,
            foreignObjectProps,
            navigate,
            isSubtasks,
            setState,
            width,
            state,
            setRender,
            data,
            t,
          })
        }
        orientation="vertical"
      />
    </div>
  )
}

const renderForeignObjectNode = ({
  nodeDatum,
  toggleNode,
  foreignObjectProps,
  classes,
  setState,
  width,
  state,
  setRender,
  data,
  navigate,
  isSubtasks,
  t,
}) => {
  const user = userInfo()

  const user_id = Number(user.userId)
  const user_id_data = Number(data.user_id)
  const structureLabel =
    nodeDatum?.structure_name === 'organization'
      ? t('structure.tree_organization')
      : nodeDatum?.structure_name === 'management'
      ? t('structure.tree_management')
      : nodeDatum?.structure_name === 'branch'
      ? t('structure.tree_branch')
      : t('structure.tree_sector')
  return (
    <>


      <foreignObject {...foreignObjectProps} >
       <Button
        className={styles.button}
        variant="contained"

      >
        {user_id === user_id_data ?  <p className={styles.open} onClick={() => setState({isPaneOpen: true , id:nodeDatum?.id , title:nodeDatum?.name, structure_name:nodeDatum?.structure_name })} >{t('structure.add')}</p> : null}


       {user_id === user_id_data && (

        <p className={styles.open} onClick={() => setState({isPaneOpen: true , id:nodeDatum?.id , title:nodeDatum?.name, structure_name:nodeDatum?.structure_name })} >{t('structure.edit_btn')}</p>
        )}
        <p>{structureLabel}</p>
        <div className={styles.name}>{nodeDatum?.name}</div>



      </Button>
      </foreignObject>
      {width > 600 ? (
        <>
          <SlidingPaneUtil
            size="900px"
            title={t('structure.hr_dept')}
            state={state}
            setState={setState}
            onRequestClose={() => {
              setState({ isPaneOpen: false })
            }}
          >
            {' '}
            <AddEmployeeForm
              data={{
                id: state?.id,
                title: state?.title,
                structure_name: state?.structure_name,
              }}
              setRender={setRender}
              setState={setState}
            />
          </SlidingPaneUtil>
        </>
      ) : (
        <>
          <SlidingPaneUtil
            size="100%"
            title={t('structure.hr_dept')}
            state={state}
            setState={setState}
            onRequestClose={() => {
              setState({ isPaneOpen: false })
            }}
          >
            {' '}
            <AddEmployeeForm
              data={{
                id: state?.id,
                title: state?.title,
                structure_name: state?.structure_name,
              }}
              setRender={setRender}
              setState={setState}
            />
          </SlidingPaneUtil>
        </>
      )}
    </>
  )
}
